// Privana-authored presentation only; tenant content and evidence remain verbatim.
export default {
  "copy": {
    "selectAnActiveFrameworkVersion": "Selezionare una versione di framework Active.",
    "thisFrameworkIsNotApplicableToThisClub": "Questo quadro non è applicabile a questo club.",
    "selectACompletedAssessmentFromTheSameFramework": "Selezionare una valutazione completa dalla stessa struttura.",
    "aCompletedPriorAssessmentIsRequired": "È richiesta una valutazione preliminare completa.",
    "selectAnActiveMemberOfThisClubSStaff": "Selezionare un membro attivo del personale di questo club.",
    "startTheAssessmentBeforeEvaluatingControls": "Avviare la valutazione prima di valutare i controlli.",
    "completedAndCancelledAssessmentsAreImmutable": "Le valutazioni completate e cancellate sono immutabili.",
    "selectAValidAssessmentResult": "Selezionare un risultato di valutazione valido.",
    "addAMeaningfulNarrativeForThisResult": "Aggiungi una narrazione significativa per questo risultato.",
    "evaluateEveryControlBeforeCompletingTheAssessment": "Valutare ogni controllo prima di completare la valutazione.",
    "youDoNotHavePermissionToPerformThisOperation": "Non hai il permesso di eseguire questa operazione.",
    "theAssessmentWasNotFoundForThisClub": "La valutazione non è stata trovata per questo club.",
    "anActiveFindingAlreadyExistsForThisAssessmentResult": "Una ricerca attiva esiste già per questo risultato di valutazione.",
    "onlyPartiallyCompliantOrNonCompliantResultsCanBecomeFindings": "Solo risultati parzialmente conformi o non conformi possono diventare Findings.",
    "selectLowMediumHighOrCritical": "Seleziona Low, Medium, High o Critical.",
    "enterAFindingTitle": "Inserire un titolo di ricerca.",
    "describeTheComplianceDeficiency": "Descrivi la carenza di conformità.",
    "theAssessmentOperationCouldNotBeCompleted": "Non è stato possibile completare l’operazione di valutazione.",
    "assessments": "Valutazione",
    "evaluateEveryCanonicalControlInAnActiveFrameworkVersion": "Valutare ogni controllo canonico in una versione quadro attiva.",
    "newAssessment": "Nuova valutazione",
    "searchAssessments": "Valutazioni di ricerca",
    "searchAssessments2": "Valutazione della ricerca...",
    "status": "Stato",
    "framework": "Quadro",
    "assessmentType": "Tipo di valutazione",
    "all": "Tutti",
    "loadingAssessments": "Caricamento delle valutazioni...",
    "noAssessmentsYet": "Ancora nessuna valutazione",
    "assessmentsEvaluateYourClubAgainstTheControlsInAnActiveComplianceFramework": "Le valutazioni valutano il tuo club contro i controlli in un quadro di conformità attivo.",
    "createAssessment": "Creare la valutazione",
    "assessment": "Valutazione",
    "version": "Versione",
    "type": "Tipo",
    "owner": "Proprietario",
    "progress": "Progressi",
    "started": "Iniziato",
    "completed": "Completato",
    "updated": "Aggiornato",
    "evaluated": " valutata",
    "selectActiveFrameworkVersion": "Selezionare la versione framework attiva",
    "controls": "controlli di controllo",
    "assessmentTitle": "Titolo della valutazione",
    "defaultToMe": "Predefinito per me",
    "loadingCompletedAssessments": "Caricamento delle valutazioni completate...",
    "selectCompletedPriorAssessment": "Selezionare la valutazione preliminare completata",
    "completed2": "· Completato",
    "noCompletedAssessmentsAreAvailableForReassessmentAgainstThisFramework": "Non sono disponibili valutazioni completate per la rivalutazione contro questo quadro.",
    "createDraftAssessment": "Creare un progetto di valutazione",
    "unassigned": "Non assegnato",
    "created": "Creato",
    "complete": "% completo",
    "startAssessment": "Valutazione dell'avvio",
    "completeAssessment": "Valutazione completa",
    "cancel": "Annulla",
    "searchControls": "Controlli di ricerca...",
    "category": "Categoria",
    "result": "Risultato",
    "importance": "Importanza",
    "controlVersion": "· Versione di controllo {version}",
    "requirement": "Requisito",
    "guidance": "Orientamento",
    "applicabilityGuidance": "Guida alla domanda",
    "evaluationMethod": "Metodo di valutazione",
    "evidenceMethod": "Metodo di prova",
    "reviewFrequency": "Frequenza di valutazione",
    "currentAssessmentResult": "Risultato della valutazione attuale",
    "assessmentNarrative": "Valutazione della narrazione",
    "saveEvaluation": "Salva valutazione",
    "finding": "Trovare",
    "raiseFinding": "Ricerca di Raise",
    "title": "Titolo",
    "description": "Descrizione",
    "severity": "Severità",
    "onlyCompletedAssessmentsCanBeUsedForAnAuditPack": "Solo le valutazioni completate possono essere utilizzate per un Audit Pack.",
    "thisAuditPackCouldNotBeFound": "Questo Audit Pack non è stato trovato.",
    "thisAuditPackCanNoLongerBeChanged": "Questo Audit Pack non può più essere modificato.",
    "thisAuditPackIsAlreadyBeingGenerated": "Questo Audit Pack è già stato generato.",
    "generationOwnershipChangedRefreshAndTryAgain": "La proprietà della generazione è cambiata. Rifiutare e riprovare.",
    "tooManyCurrentEvidenceDocumentsAreInScope": "Troppi documenti attuali di prova sono nel campo di applicazione.",
    "theEvidencePackageIsTooLargeToGenerateSafely": "Il pacchetto Evidence è troppo grande per generare in modo sicuro.",
    "aCurrentEvidenceDocumentCouldNotBeRetrievedNoIncompletePackageWasGenerated": "Un documento di prova corrente non potrebbe essere recuperato. Nessun pacchetto incompleto è stato generato.",
    "enterARationaleBeforeVoidingThisAuditPack": "Inserire una razionalità prima di annullare questo Audit Pack.",
    "unableToCompleteTheAuditPackOperation": "Incapace di completare l'operazione Audit Pack.",
    "loadingAssuranceOverview": "Panoramica delle assicurazioni di caricamento...",
    "setUpYourComplianceProgramme": "Impostare il programma Compliance",
    "privanaCanHelpYouBuildAStructuredAssuranceProgrammeForYourClub": "Privana può aiutarvi a costruire un programma di garanzia strutturato per il vostro club.",
    "chooseAFramework": "Scegli un Quadro",
    "startWithAPrivanaTemplateOrCreateYourOwn": "Inizia con un modello Privana o crea il tuo.",
    "reviewYourControls": "Recensione dei tuoi Controlli",
    "tailorTheSuggestedRequirementsToYourClub": "Adatta i requisiti suggeriti al tuo club.",
    "runYourFirstAssessment": "Esegui la tua prima valutazione",
    "establishYourCurrentCompliancePosition": "Stabilisci la tua attuale posizione di conformità.",
    "step": "Passo",
    "setUpCompliance": "Impostare la conformità",
    "overallCompliance": "Compliance globale",
    "notAssessed": "Non valutato",
    "openFindings": "Risultati aperti",
    "actionsDue": "Azioni Due",
    "auditReadiness": "Audit Prontezza",
    "notEnoughData": "Non abbastanza dati",
    "assuranceReadinessIndicatorNotCertification": "Indicatore di prontezza di assicurazione, non certificazione",
    "executiveAssurance": "Assicurazione esecutiva",
    "currentAssurancePostureFromCanonicalComplianceRecords": "La postura attuale della garanzia dai registri canonici della conformità.",
    "readinessDimensions": "Dimensioni di lettura",
    "notMeasurable": "Non misurabile",
    "recentComplianceActivity": "Attività di Compliance",
    "timesShownIn": "Gli orari mostrati",
    "auditPacks": "Pacchetti di audit",
    "immutableVersionedAssuranceSnapshotsForFormalReview": "Immutable, versioned snapshot di garanzia per la revisione formale.",
    "newAuditPack": "Nuovo pacchetto Audit",
    "searchAuditPacks": "Ricerca di pacchetti di audit",
    "searchPacks": "Cerca i pacchetti...",
    "statusFilter": "Filtro di stato",
    "allStatuses": "Tutti gli stati",
    "draft": "Bozza",
    "generating": "Generazione",
    "generated": "Generazione",
    "void": "Annullato",
    "noAuditPacks": "Nessun pacchetto di audit",
    "createAPackFromACompletedAssessment": "Creare un pacchetto da una valutazione completata.",
    "pack": "Confezione",
    "generatedBy": "Generato da",
    "documents": "Documenti",
    "selectCompletedAssessment": "Seleziona la valutazione completa...",
    "includeEvidenceDocuments": "Includere documenti di prova",
    "createDraft": "Creare un progetto",
    "noDescriptionProvided": "Nessuna descrizione fornita.",
    "generateAuditPack": "Pacchetto di Audit Generate",
    "generatingAuditPack": "Generando Audit Pack...",
    "theImmutableReportAndAuthorisedEvidencePackageAreBeingPreparedRefreshToCheckItsStatus": "La relazione immutabile e il pacchetto Evidence autorizzato sono in fase di preparazione. Rifiutare di controllare il suo stato.",
    "manifestV": "Manifestazione contro",
    "downloadPDF": "Scarica PDF",
    "downloadEvidencePackage": "Scarica il pacchetto delle prove",
    "voidAuditPack": "Pacchetto Audit Void",
    "voidingIsTerminalExplainWhyThisDraftMustNotBeGenerated": "Voiding è terminale. Spiegare perché questo progetto non deve essere generato.",
    "voidRationale": "Razionalità Void",
    "voidRationale2": "Void razionali...",
    "actionDue": "Azione dovuta",
    "safetyReview": "Recensione di sicurezza",
    "complianceDate": "Data di conformità",
    "owner2": "Titolare:",
    "priority": "priorità",
    "overdue": "Scaduto",
    "open": "Apri",
    "youDoNotHaveAccessToTheComplianceCalendar": "Non hai accesso al Calendario Compliance.",
    "theComplianceCalendarCouldNotBeLoaded": "Il Calendario di Compliance non poteva essere caricato.",
    "complianceCalendar": "Calendario di conformità",
    "dueThisWeek": "A causa di questa settimana",
    "next30Days": "I prossimi 30 giorni",
    "safetyReviewsDue": "Recensioni di sicurezza dovute",
    "previousMonth": "Mese precedente",
    "today": "Oggi",
    "nextMonth": "Il mese prossimo",
    "calendarView": "Calendario di vista",
    "calendar": "Calendario",
    "agenda": "Ordine del giorno",
    "filters": "Filtri",
    "eventCategory": "Categoria Evento",
    "allEvents": "Tutti gli eventi",
    "actions": "Azioni",
    "frameworks": "Quadri",
    "safetyReviews": "Recensioni di sicurezza",
    "timing": "Tempistiche",
    "allDates": "Tutti gli appuntamenti",
    "upcoming": "Prossimo",
    "loadingComplianceDates": "Date di conformità al caricamento",
    "loadingComplianceDates2": "Caricamento date di conformità...",
    "sun": "Sole",
    "mon": "Mon",
    "tue": "Martedì",
    "wed": "Gregge",
    "thu": "Gioiello",
    "fri": "Frigo.",
    "sat": "Rasoio",
    "more": "di più",
    "selectedDayAgenda": "Ordine del giorno selezionato",
    "noComplianceItemsForThisDay": "Nessun elemento di conformità per questo giorno.",
    "noComplianceDatesInThisPeriod": "Nessuna data di conformità in questo periodo",
    "today2": " · Oggi",
    "date": "Data",
    "andTime": " e il tempo",
    "sourceReference": "Riferimenti",
    "context": "Contesto",
    "priority2": "Priorità",
    "close": "Chiudi",
    "thatKeyAndVersionAlreadyExists": "Quella chiave e la versione esistono già.",
    "activeAndRetiredControlsCannotBeEditedCreateANewVersionInstead": "I controlli attivi e in pensione non possono essere modificati. Creare una nuova versione invece.",
    "onlyDraftFrameworkVersionsCanHaveTheirControlsChanged": "Solo le versioni di progetto possono avere i loro controlli modificati.",
    "activateEveryAttachedControlBeforeActivatingThisVersion": "Attivare ogni controllo allegato prima di attivare questa versione.",
    "onlyActiveControlsCanBeAssignedToAFrameworkVersion": "Solo i controlli attivi possono essere assegnati a una versione framework.",
    "controlOrderingMustUseNonNegativeWholeNumbers": "L'ordine di controllo deve usare numeri interi non negativi.",
    "eachAssignedControlMustHaveAUniqueOrder": "Ogni controllo assegnato deve avere un ordine unico.",
    "thisFrameworkAlreadyHasAnActiveVersionSupersedeOrRetireItExplicitlyFirst": "Questo framework ha già una versione Active. Superare o ritirarlo esplicitamente prima.",
    "aRationaleIsRequiredWhenAFrameworkIsNotApplicable": "Una razionalità è necessaria quando un quadro non è applicabile.",
    "theEffectiveToDateMustBeOnOrAfterEffectiveFrom": "L'effettivo-alla data deve essere su o dopo efficace-da.",
    "youDoNotHaveComplianceEditPermission": "Non hai il permesso di modificare Compliance.",
    "attachAtLeastOneActiveControlBeforeActivation": "Collegare almeno un controllo attivo prima dell'attivazione.",
    "createAFrameworkVersionBeforeActivatingThisFramework": "Creare una versione framework prima di attivare questo framework.",
    "thisLifecycleActionIsNotValidForTheCurrentStatus": "Questa azione del ciclo di vita non è valida per lo stato attuale.",
    "theComplianceOperationCouldNotBeCompleted": "L'operazione di conformità non poteva essere completata.",
    "no": "No",
    "yet": " ancora",
    "controlsDefineTheRequirementsUsedByComplianceFrameworksAndAssessments": "I controlli definiscono i requisiti utilizzati dai quadri e dalle valutazioni di conformità.",
    "frameworksOrganiseReusableControlsIntoADefinedComplianceProgramme": "I quadri organizzano controlli riutilizzabili in un programma di conformità definito.",
    "create": "Creare",
    "control": "Controllo",
    "privanaWillGenerateTheControlReferenceAutomatically": "Privana genererà automaticamente il riferimento di controllo.",
    "controlDefinition": "Definizione del controllo",
    "assuranceSettings": "Impostazioni di assicurazione",
    "controlLibrary": "Biblioteca di controllo",
    "reusableVersionedRequirementsForYourComplianceProgrammes": "Reusable, requisiti versioned per i vostri programmi di conformità.",
    "browsePrivanaLibrary": "Sfoglia la libreria Privana",
    "newControl": "Nuovo controllo",
    "searchControls2": "Controlli di ricerca",
    "allCategories": "Tutti i gruppi",
    "allImportance": "Tutta l'importanza",
    "loadingControls": "Comandi di caricamento...",
    "evaluation": "Valutazione",
    "evidence": "Prove",
    "createControl": "Creare il controllo",
    "frameworkReferences": "Riferimenti quadro",
    "edit": "Modifica",
    "activate": "Attivare",
    "createNewVersion": "Crea nuova versione",
    "retire": "Respinta",
    "editDraftControl": "Modifica del progetto di controllo",
    "saveChanges": "Salvare le modifiche",
    "createNewControlVersion": "Crea nuova versione di controllo",
    "createDraftVersion": "Crea un progetto di versione",
    "availableControls": "Controlli disponibili",
    "available": "disponibile",
    "searchAvailableControls": "Cerca i controlli disponibili",
    "searchActiveControls": "Cerca Controllo attivo...",
    "availableControlCategory": "Categoria di controllo disponibile",
    "availableControlImportance": "Importanza di controllo disponibile",
    "version2": "· Versione",
    "add": "Aggiungi",
    "allMatchingControlsAreAlreadyAssigned": "Tutti i Controlli corrispondenti sono già assegnati.",
    "assignedControls": "Controlli assegnati",
    "assigned": "assegnato",
    "searchAssignedControls": "Controlli assegnati alla ricerca",
    "searchAssignedControls2": "Ricerca assegnata Controlli...",
    "frameworkReferenceFor": "Riferimento quadro",
    "frameworkReferenceOptional": "Riferimento quadro (opzionale)",
    "moveUp": "Muovetevi",
    "moveDown": "Muovetevi",
    "removeControl": "Rimuovere il controllo",
    "noAssignedControlsMatchThisSearch": "Nessun controllo assegnato corrisponde a questa ricerca.",
    "controlsAssigned": "Controlli assegnati",
    "privanaComplianceLibrary": "Privana Biblioteca di conformità",
    "loadingPrivanaTemplates": "Caricamento di Privana modelli...",
    "privanaLibraryIsTemporarilyUnavailableYouCanStillBuildACustomFramework": "Privana Biblioteca è temporaneamente non disponibile. È ancora possibile costruire un Framework personalizzato.",
    "privanaTemplatesAreGuidanceAndShouldBeTailoredWithAppropriateProfessionalAdvice": "Privana modelli sono guida e dovrebbero essere adattati con una consulenza professionale adeguata.",
    "chooseTheSuggestedControlsToCopyIntoYourDraftProgrammeYouCanReviewAndTailorThemBeforeActivation": "Scegli i Controlli consigliati da copiare nel tuo programma Draft. Puoi rivederli e adattarli prima dell'attivazione.",
    "selectAll": "Seleziona tutto",
    "clearAll": "Cancella tutto",
    "suggestedEvidence": "· Prove suggerite:",
    "reviewDuringTailoring": "Recensione durante la sartoria",
    "privanaTemplatesProvideAStructuredStartingPointForYourClubSAssuranceProgrammeReviewAndTailorEachProgrammeToYourOrganisationJurisdictionInsurerAndProfessionalAdviceBeforeActivation": "Privana modelli forniscono un punto di partenza strutturato per il programma di assicurazione del vostro club. Recensione e personalizzare ogni programma per la vostra organizzazione, giurisdizione, assicurazione e consulenza professionale prima dell'attivazione.",
    "searchTemplates": "Modelli di ricerca",
    "searchTemplates2": "Modelli di ricerca...",
    "templateCategory": "Categoria modello",
    "recommended": "Consigliato",
    "privanaTemplate": "Privana modello ·",
    "controls2": "Controlli",
    "preview": "Anteprima",
    "useThisTemplate": "Utilizzare questo modello",
    "backToTemplates": "Torna ai modelli",
    "selected": "selezionato",
    "creatingDraft": "Creare bozza...",
    "adoptDraftControls": "Adottare bozze di controlli",
    "createDraftFramework": "Creare un progetto quadro",
    "frameworkRetiredSuccessfully": "Framework si ritirò con successo.",
    "notConfigured": "Non configurato",
    "createAndManageVersionedComplianceProgrammes": "Creare e gestire programmi di conformità versioned.",
    "newFramework": "Nuovo quadro",
    "searchFrameworks": "Quadri di ricerca",
    "searchFrameworks2": "Quadri di ricerca...",
    "frameworkStatus": "Situazione",
    "loadingFrameworks": "Cornici di carico...",
    "chooseHowYourClubWantsToEstablishItsAssuranceProgramme": "Scegli come il tuo club vuole stabilire il suo programma di assicurazione.",
    "startFromPrivanaLibrary": "Inizio da Privana Biblioteca",
    "chooseACuratedAssuranceProgrammeAndTailorTheSuggestedControls": "Scegli un programma di assicurazione curato e adatta i Controlli consigliati.",
    "buildACustomFramework": "Costruire un quadro personalizzato",
    "createAProgrammeFromScratchForAClubSpecificOrExternalRequirement": "Creare un programma da zero per un requisito specifico o esterno del club.",
    "currentVersion": "Versione attuale",
    "versions": "Versioni",
    "applicability": "Applicabilità",
    "notSet": "Non impostato",
    "createFrameworkAndFirstDraftVersion": "Creare Framework e il primo progetto di versione",
    "privanaWillGenerateTheFrameworkReferenceAndInitialVersionAutomatically": "Privana genererà automaticamente il riferimento Framework e la versione iniziale.",
    "name": "Nome",
    "versionTitle": "Titolo della versione",
    "effectiveFrom": "Efficace da",
    "effectiveTo": "Efficace",
    "createdFromPrivanaComplianceLibrary": "Creato da Privana Compliance Library",
    "versionStatus": "Stato della versione",
    "activeControls": "Controlli attivi",
    "awaitingReview": "Recensione in attesa",
    "reviewAndActivateAllAttachedControlsFirst": "Esaminare e attivare tutti i Controlli collegati prima.",
    "activateVersion": "Attiva la versione",
    "manageControls": "Gestione dei controlli",
    "editApplicability": "Modifica Applicabilità",
    "setApplicability": "Set Applicabilità",
    "newVersion": "Nuova versione",
    "moreVersionActions": "Altre azioni di versione",
    "supersedeVersion": "Versione Supersede",
    "markThisVersionAsHistorical": "Segna questa versione come storica",
    "retireVersion": "Retire la versione",
    "removeFromFutureActiveUse": "Rimuovere dal futuro uso attivo",
    "deEmphasisedDuringInitialSetup": "De-emphasised durante la configurazione iniziale",
    "activateFramework": "Attivare il quadro",
    "moreFrameworkActions": "Altre azioni quadro",
    "retireFramework": "Quadro reticolare",
    "removeFromFutureAssuranceUse": "Rimuovere dall'uso futuro dell'assicurazione",
    "versionHistory": "Storia della versione",
    "noStartDate": "Nessuna data di inizio",
    "openEnded": "Finitura aperta",
    "selectedVersionWorkspace": "Spazio di lavoro della versione selezionata",
    "reviewSuggestedControls": "Recensione consigliata Controlli",
    "controlsReviewed": "Controlli esaminati",
    "reviewed": "riesaminato",
    "anAuthorizedControlsEditorMustReviewAndActivateTheseControls": "Un editor di Controls autorizzato deve rivedere e attivare questi Controls.",
    "reviewControls": "Controlli di revisione",
    "readyToActivateVersion": "Pronta per attivare la versione",
    "total": "Totale",
    "active": "Attivo",
    "awaitingReview2": "Recensione di risveglio",
    "retired": "Ritiro",
    "searchControls3": "Controlli di ricerca",
    "searchControls4": "Controllo di ricerca...",
    "controlStatusFilter": "Filtro di stato di controllo",
    "controlCategoryFilter": "Filtro di categoria di controllo",
    "frameworkOrder": "Ordine quadro",
    "uncategorised": "Non categorizzato",
    "noReference": "Nessun riferimento",
    "noControlsMatchTheseFilters": "Nessun controllo corrisponde a questi filtri.",
    "createDraftFrameworkVersion": "Crea la versione di Draft Framework",
    "copyControlsFromVersion": "Comandi di copia dalla versione",
    "doNotCopyControls": "Non copiare i controlli",
    "searchSuggestedControls": "Ricerca consigliata Controlli",
    "reviewCategoryFilter": "Filtro di categoria di revisione",
    "reviewImportanceFilter": "Filtro di importanza recensione",
    "reviewStatusFilter": "Filtro di stato della recensione",
    "selectAllDraft": "Seleziona tutti i progetti",
    "clearSelection": "Selezione chiara",
    "evidence2": "· Prove:",
    "noRequirementSummary": "Nessun riepilogo dei requisiti.",
    "openControl": "Controllo aperto",
    "activateSelectedControls": "Attivare Controlli selezionati",
    "controlsEditPermissionRequired": "Controlli modificare il permesso richiesto",
    "chooseWhichActiveControlsBelongToThisDraftFrameworkVersionAndArrangeHowTheyAppearWithinTheProgramme": "Scegliere quale Controlli attivi appartengono a questa Versione Quadro e organizzare come appaiono all'interno del programma.",
    "controlAssignmentsSaved": "Incarichi di controllo salvati.",
    "discardUnsavedChanges": "Eliminare i cambiamenti non salvati?",
    "yourStagedControlMembershipChangesWillNotBeSaved": "I cambiamenti dei soci del controllo in fase non saranno salvati.",
    "keepEditing": "Continua a modificare",
    "discardChanges": "Discard Cambiamenti",
    "frameworkApplicability": "Applicabilità del quadro",
    "doesThisProgrammeApplyToYourClub": "Questo programma si applica al tuo club?",
    "recordWhetherThisFrameworkVersionAppliesToTheClubAndWhereUsefulTheReasonAndApplicablePeriod": "Registrare se questa versione quadro si applica al club e, se utile, la ragione e il periodo applicabile.",
    "applicable": "Applicabile",
    "underReview": "Rassegna",
    "notApplicable": "Non applicabile",
    "reasonThisDoesNotApply": "Motivo che non si applica",
    "reviewNotes": "Osservazioni",
    "applicableFrom": "Applicabile da",
    "applicableTo": "Applicabile a",
    "theseOptionalDatesDefineThePeriodForWhichThisApplicabilityDecisionApplies": "Queste date facoltative definiscono il periodo per il quale si applica la presente decisione di applicabilità.",
    "saveApplicability": "Salvare l'applicabilità",
    "retireFramework2": "Retire il quadro?",
    "retiringThisFrameworkRemovesItFromFutureActiveAssuranceUseWhilePreservingItsVersionsAssessmentsFindingsActionsEvidenceAndAuditHistory": "Ritirare questo quadro lo rimuove dal futuro uso di assicurazione attiva, preservando le sue versioni, valutazioni, risultati, azioni, prove e storia di audit.",
    "retirementRationale": "Razionalità del pensionamento",
    "programmeRetiredFollowingReplacementByAConsolidatedAssuranceFramework": "Il programma si è ritirato in seguito alla sostituzione di un quadro consolidato di garanzia.",
    "supersedeFrameworkVersion": "Versione Quadro Supersede?",
    "retireFrameworkVersion": "Retire la versione Framework?",
    "supersedingThisVersionMarksItAsHistoricalAndPreventsItFromBeingTreatedAsTheCurrentActiveVersionExistingAssessmentsFindingsActionsEvidenceAndAuditHistoryRemainUnchanged": "Superando questa versione lo segna come storico e impedisce di essere trattato come la versione attiva corrente. Le valutazioni esistenti, i risultati, le azioni, le prove e la storia dell'audit rimangono invariate.",
    "retiringThisVersionRemovesItFromFutureActiveUseWhilePreservingItsHistoricalAssessmentsEvidenceAndAuditRecord": "Retiring questa versione lo rimuove dal futuro uso attivo, mantenendo le sue valutazioni storiche, prove e record di audit.",
    "supersedeRationale": "Razionalità del Supersede",
    "replacedByThe2027AssuranceBaseline": "Sostituito dalla linea di base di garanzia 2027.",
    "evidenceWorkspaces": "Prove spazi di lavoro",
    "evidenceRegister": "Registro delle prove",
    "insuranceIntelligence": "Assicurazione",
    "unableToLoadEvidence": "Incapace di caricare le prove.",
    "evidenceWasNotFound": "Le prove non sono state trovate.",
    "unableToCreateEvidence": "Incapace di creare Evidence.",
    "uploadAGenuinePDFPNGOrJPEGDocument": "Caricare un documento originale PDF , PNG o JPEG.",
    "filesMustBe20MBOrSmaller": "I file devono essere 20 MB o più piccoli.",
    "documentUploadFailedPleaseTryAgain": "L'upload del documento non è riuscito.",
    "thePrivateDocumentCouldNotBeOpened": "Il documento privato non poteva essere aperto.",
    "unableToUpdateEvidence": "Incapace di aggiornare le prove.",
    "thatLifecycleTransitionIsNotAllowed": "Quella transizione del ciclo di vita non è consentita.",
    "unableToLinkEvidence": "Incapace di collegare Evidence.",
    "canonicalAssuranceRecordsSupportingYourComplianceProgramme": "Documenti di assicurazione canonica che supportano il tuo programma Compliance.",
    "addEvidence": "Aggiungere le prove",
    "activeEvidence": "Prove attive",
    "uploadedDocuments": "Documenti caricati",
    "manualEvidence": "Prove manuali",
    "unlinkedEvidence": "Prove non collegate",
    "searchEvidence": "Prove di ricerca",
    "allSourceTypes": "Tutti i tipi di sorgente",
    "manual": "Manuale",
    "uploadedDocument": "Documento scaricato",
    "allLinkedStates": "Tutti gli stati collegati",
    "linked": "Collegamento",
    "unlinked": "Non collegato",
    "noEvidenceYet": "Ancora nessuna prova",
    "evidenceProvidesTheRecordsDocumentsAndAssuranceMaterialThatSupportYourComplianceControlsAssessmentsFindingsAndRemediation": "La prova fornisce i documenti, documenti e materiale di garanzia che supportano i controlli di conformità, le valutazioni, i risultati e la bonifica.",
    "captured": "Acquisito",
    "links": "Link link",
    "createdBy": "Creato da",
    "previous": "Precedente",
    "page": "Pagina",
    "records": "record",
    "next": "Avanti",
    "recordAnAttestationOrOtherManuallyCapturedAssuranceItem": "Registra un'attestazione o un altro elemento di garanzia acquisito manualmente.",
    "uploadDocument": "Documento di caricamento",
    "securelyAttachAPrivatePDFOrImageDocument": "Allegare saldamente un documento privato PDF o immagine.",
    "changeEvidenceType": "← Cambiare tipo di prova",
    "optionalSourceReference": "Riferimento facoltativo",
    "capturedAt": "Acquisito il",
    "file": "File",
    "pDFPNGOrJPEGMaximum20MB": "PDF , PNG o JPEG · massimo 20 MB",
    "sourceManualStatusActive": "Fonte: Manuale · Stato: Attivo",
    "uploading": "Caricamento...",
    "createEvidence": "Creare prove",
    "sourceType": "Tipo di sorgente",
    "sourceSystem": "Sistema sorgente",
    "sourceReference2": "Riferimento",
    "createdAt": "Creato a",
    "updatedAt": "Aggiornato At",
    "lifecycleReason": "Motivo del ciclo di vita",
    "sizeUnavailable": "Dimensione non disponibile",
    "viewDownload": "Visualizza / Scarica",
    "noDescription": "Nessuna descrizione.",
    "editMetadata": "Modifica dei metadati",
    "supersede": "Sostituisci",
    "withdraw": "Ritiro",
    "saveMetadata": "Salva i metadati",
    "linkedTo": "Linked a",
    "unlinkEvidence": "Prove di collegamento",
    "selectTarget": "Selezionare l'obiettivo",
    "linkEvidence": "Prove di collegamento",
    "insuranceAnalysisComplete": "Analisi assicurativa completa",
    "viewInsights": "Visualizza le istruzioni",
    "viewInsuranceIntelligence": "Visualizza l'Intelligence di Assicurazione",
    "needsClubReview": "Bisogno recensione club",
    "needsReview": "Bisogno recensione",
    "theInsurancePolicySetCouldNotBeLoaded": "Il set di polizze assicurative non potrebbe essere caricato.",
    "liveProgressConnectionWasInterruptedYourAnalysisIsStillRunning": "La connessione al progresso live è stata interrotta. La tua analisi e' ancora in funzione.",
    "viewComplianceImpact": "Visualizza l'impatto della conformità",
    "continueReview": "Continua a leggere",
    "reviewRecommendations": "Raccomandazioni di valutazione",
    "uploadFailed": "Caricamento in corso",
    "uploadAtLeastOneValidPDFBeforeAnalysis": "Caricare almeno un PDF valido prima dell'analisi.",
    "analysisCouldNotBeStarted": "L'analisi non potrebbe essere iniziata.",
    "thisRecommendationHasAlreadyBeenReviewed": "Questa raccomandazione è già stata esaminata.",
    "weCouldnTSaveThisDecisionPleaseTryAgain": "Non siamo riusciti a salvare questa decisione.",
    "frameworkVersionsCouldNotBeLoaded": "Le Versioni Quadrate non potevano essere caricate.",
    "reviewTheHighlightedControlFieldsBeforeCreatingIt": "Rivedere i campi di controllo evidenziati prima di crearlo.",
    "anotherAdoptionIsAlreadyInProgressPleaseRefreshInAMoment": "Un'altra adozione è già in corso. Si prega di rinfrescare in un momento.",
    "theSelectedFrameworkVersionIsNoLongerEditable": "La versione Framework selezionata non è più modificabile.",
    "thisControlAlreadyExistsInYourClub": "Questo controllo esiste già nel tuo club.",
    "weCouldnTAddThisLibraryControlPleaseTryAgain": "Non abbiamo potuto aggiungere questo controllo della biblioteca.",
    "weCouldnTCreateThisDraftControlPleaseTryAgain": "Non siamo riusciti a creare questo Draft Control, per favore riprovate.",
    "thisControlMustBeActiveBeforeItCanBeAddedToTheFramework": "Questo controllo deve essere attivo prima che possa essere aggiunto al Framework.",
    "weCouldnTCancelThisFrameworkIntentionPleaseTryAgain": "Non siamo riusciti a cancellare l'intenzione di questo quadro.",
    "thisOutlookReminderAlreadyExists": "Questo promemoria di Outlook esiste già.",
    "outlookReminderCreated": "Promemoria di Outlook creato.",
    "calendarPermissionIsNeededConnectOutlookCalendarWithoutChangingYourMailConnection": "È necessario il permesso del calendario. Collegare il calendario di Outlook senza modificare la connessione della posta.",
    "theOutlookReminderCouldNotBeCreated": "Il promemoria di Outlook non potrebbe essere creato.",
    "loadingInsurancePolicy": "Caricamento in corso...",
    "insuranceIntelligence2": "← Assicurazione Intelligenza",
    "insuranceIntelligence3": "Intelligenza delle assicurazioni ·",
    "reviewComplete": "Recensione completa",
    "reviewInProgress": "Rassegna in corso",
    "analysisComplete": "Analisi completa",
    "preparingAnalysis": "Preparazione dell'analisi",
    "reanalyse": "Rianalizza",
    "insurer": "Assicurazione",
    "policyNumber": "Numero della politica",
    "policyPeriod": "Periodo di validità",
    "primaryLimit": "Limiti primari",
    "excess": "Eccessiva",
    "underwriter": "Assicuratore",
    "analysing": "Analizzare",
    "of": "di",
    "pagesProcessed": "pagine trattate",
    "yourPreviousCompletedAnalysisRemainsAvailableWhileThisAnalysisRuns": "La tua precedente analisi completa rimane disponibile durante l'esecuzione di questa analisi.",
    "analysisCouldNotBeCompleted": "L'analisi non poteva essere completata",
    "yourDocumentsAndAnyPreviousCompletedAnalysisAreSafePleaseTryAgain": "I vostri documenti e qualsiasi precedente analisi completa sono sicuri. Si prega di riprovare.",
    "retryAnalysis": "Analisi del processo",
    "importantForYourAttention": "Importante per la vostra attenzione",
    "whyThisMatters": "Perché questo è importante",
    "page2": "· pagina",
    "viewSource": "· Visualizza sorgente",
    "policyReview": "Revisione delle politiche",
    "privanaFoundRecommendationsFromThisPolicyReviewThemBeforeAnythingChangesInCompliance": "Privana ha trovato raccomandazioni da questa politica. Esaminali prima che cambi qualcosa di Compliance.",
    "reviewed2": "recensito ·",
    "remaining": "rimanente",
    "existingMatches": "fiammiferi esistenti ·",
    "suggestedControls": "Controlli consigliati ·",
    "dates": "date ·",
    "needsReview2": "bisogno di revisione",
    "existingControlsMatched": "Controlli esistenti abbinati",
    "privanaFoundControlsThatMayAlreadyAddressPolicyRequirements": "Privana ha trovato Controlli che possono già soddisfare i requisiti di politica.",
    "suggestedControls2": "Controlli consigliati",
    "requirementsThatMayNeedAnAdditionalControlOrClubReview": "Requisiti che possono avere bisogno di un controllo aggiuntivo o di una recensione club.",
    "importantDates": "date importanti",
    "policyDatesAndPreparationMilestonesIdentified": "Date di politica e pietre miliari di preparazione identificate.",
    "review": "Recensione",
    "matches": "Corrispondenza",
    "suggestedControls3": "Controlli consigliati",
    "dates2": "Date",
    "reviewFilter": "Filtro di revisione",
    "whatThePolicyRequires": "Che cosa richiede la politica",
    "policyRequirement": "Obbligo politico",
    "privanaSRecommendedMatch": "Privana partita consigliata",
    "privanaSSuggestedControl": "Privana Controllo consigliato",
    "draftARepeatablePolicyComplianceControl": "Si tratta di una conformità politica ripetibile",
    "status2": "Stato:",
    "frameworks2": "Quadri:",
    "none": "Nessuno",
    "latestAssessment": "Valutazione più recente:",
    "notAssessed2": "non valutata",
    "evidence3": "Prove:",
    "supported": "Supportato",
    "noCurrentSupport": "Nessun supporto attuale",
    "strongMatch": "Forte match",
    "possibleMatch": "Possibile partita",
    "whyPrivanaRecommendsIt": "Perché Privana lo raccomanda",
    "libraryProvenance": "Provenienza della biblioteca:",
    "version3": "· versione",
    "addedToFramework": "Aggiunto al Framework",
    "readyToAddToFramework": "Pronti ad aggiungere a Framework",
    "waitingForControlActivation": "Attendere l'attivazione di controllo",
    "matchConfirmed": "Abbinamento confermato",
    "notAMatch": "Non un fiammifero",
    "dismissed": "Annullamento della decisione n.",
    "libraryControlAdded": "Libreria Controllo aggiunto",
    "draftControlCreated": "Progetto di controllo creato",
    "recommendationReviewed": "Raccomandazione riveduta",
    "target": "Obiettivo:",
    "viewControl": "Visualizza il controllo",
    "adding": "Aggiunta...",
    "cancelling": "Cancelliere...",
    "cancelFrameworkIntention": "Annullare l'intenzione quadro",
    "viewFramework": "Visualizza il quadro",
    "saving": "Salvataggio…",
    "confirmMatch": "Confermare la partita",
    "markForReview": "Mark per recensione",
    "addToMyControls": "Aggiungi ai miei controlli",
    "createDraftControl": "Creare un progetto di controllo",
    "frameworkEditAccessIsRequired": "L'accesso alla modifica quadro è richiesto",
    "addToFramework": "Aggiungi a Framework",
    "createAddToFramework": "Crea e aggiungi al quadro",
    "controlsEditAccessIsRequiredToAdoptThisRecommendation": "I controlli modificano l'accesso è necessario per adottare questa raccomandazione.",
    "dismiss": "Discorso",
    "youReAllCaughtUpInThisSection": "Siete tutti coinvolti in questa sezione.",
    "viewCompleted": "Vista completata",
    "privanaDerivedMilestone": "Privana -pietra derivata",
    "policyDeadline": "Termine per la presentazione",
    "policyPeriodDate": "Periodo di validità",
    "suggestedMilestoneDerivedFromPolicyInformationNotAContractualCondition": "Pietra miliare suggerita derivata da informazioni politiche — non una condizione contrattuale.",
    "viewInComplianceCalendar": "Visualizza nel Calendario Compliance",
    "addToOutlook": "Aggiungi a Outlook",
    "viewSource2": "Visualizza sorgente",
    "policyRequirements": "Requisiti di politica",
    "extractedClausesRemainAvailableGroupedForEasierReview": "restano disponibili clausole estratte, raggruppate per una revisione più semplice.",
    "expandAll": "Espandere tutto",
    "collapseAll": "Colpisci tutto",
    "confidencePage": "% fiducia · pagina",
    "privanaSInterpretation": "Privana ’ interpretazione",
    "sourceDocuments": "Documenti di origine",
    "originalDocumentsUsedForThisAnalysis": "Documenti originali utilizzati per questa analisi.",
    "addPDFs": "Aggiungi PDF",
    "pages": "pagine ·",
    "view": "Visualizza",
    "removeDocument": "Rimuovi documento",
    "analysePolicy": "Analizzare la politica",
    "privanaLibraryControl": "Privana Controllo della Biblioteca",
    "suggestedControl": "Controllo consigliato",
    "reviewThisReadOnlyLibraryControlBeforeAddingItToYourProgramme": "Rivedere questo controllo della biblioteca di sola lettura prima di aggiungerlo al vostro programma.",
    "reviewPrivanaSRecommendationBeforeAddingItToYourComplianceProgramme": "Consulta la raccomandazione di Privana prima di aggiungerla al tuo programma Compliance.",
    "destination": "Destinazione",
    "chooseTheFrameworkDestinationPrivanaWillRememberItWhileYouReviewAndActivateTheDraftControl": "Scegli la destinazione Framework. Privana lo ricorderà mentre rilevi e attiverai il Draft Control.",
    "targetFrameworkVersion": "Versione Quadro di destinazione",
    "chooseAFrameworkVersion": "Scegli una versione Framework",
    "evaluation2": "Valutazione:",
    "source": "Fonte",
    "privanaLibrary": "Privana Biblioteca ·",
    "libraryControlTemporarilyUnavailable": "Controllo Biblioteca temporaneamente non disponibile",
    "privanaCannotSafelyLoadThisHistoricalLibraryControlRightNowNoGeneratedControlWillBeSubstituted": "Privana non può caricare in modo sicuro questo storico Library Control in questo momento. Nessun controllo generato verrà sostituito.",
    "creating": "Creare...",
    "createDraftControlContinue": "Creare bozze di controllo e continuare",
    "analysisHistory": "Analisi della storia",
    "pages2": "pagine",
    "privanaProvidesPolicyInterpretationAndAssuranceSupportNotLegalCertificationReviewMaterialInsuranceMattersWithYourBrokerInsurerOrProfessionalAdviser": "Privana fornisce l'interpretazione politica e il sostegno all'assicurazione, non la certificazione legale. Verificare le questioni di assicurazione materiale con il tuo broker, assicuratore o consulente professionale.",
    "insuranceIntelligenceCouldNotBeLoaded": "L'intelligence non poteva essere caricata.",
    "thePolicySetCouldNotBeCreated": "Il set di politiche non potrebbe essere creato.",
    "turnComplexInsuranceWordingIntoClearObligationsAssuranceGapsAndActionsForYourClub": "Trasformare la formulazione di assicurazione complessa in obblighi chiari, lacune di assicurazione e azioni per il vostro club.",
    "uploadInsurancePolicy": "Politica di assicurazione di carico",
    "privanaUsesAIToIdentifyAndOrganizePotentiallyImportantPolicyWordingReviewMaterialCoverageAndContractualQuestionsWithYourBrokerInsurerOrProfessionalAdviserWhereAppropriate": "Privana utilizza l'IA per identificare e organizzare una formulazione politica potenzialmente importante. Rivedere la copertura dei materiali e le domande contrattuali con il tuo broker, assicuratore o consulente professionale, se del caso.",
    "policyTitle": "Titolo della politica",
    "insuranceType": "Tipo di assicurazione",
    "insurerOptional": "Assicuratore (facoltativo)",
    "policyNumberOptional": "Numero di criteri (facoltativo)",
    "createThePolicySetFirstThenSecurelyAddUpTo10PrivatePDFs100MBAnd1500PagesEachClassifyEachScheduleWordingOrEndorsementAndStartDurableAnalysis": "Creare il criterio impostato prima, quindi aggiungere in modo sicuro fino a 10 PDF privati (100 MB e 1.500 pagine ciascuna), classificare ogni programma, wording o approvazione, e avviare analisi durevoli.",
    "createPolicySet": "Creare Set Criteri",
    "completedSafetyChecklists": "Controlli di sicurezza completati",
    "riskAssessments": "Valutazione del rischio",
    "alertEvents": "Eventi di avviso",
    "theSourceProvidesSupportingAssuranceForTheControl": "La fonte fornisce la garanzia di supporto per il controllo.",
    "theSourceMayDemonstrateThatTheControlIsNotBeingSatisfied": "La fonte può dimostrare che il Controllo non è soddisfatto.",
    "theSourceDemonstratesCorrectiveRemediationActivity": "La fonte dimostra l'attività correttiva/rimediazione.",
    "theSourceIndependentlyVerifiesTheControlCondition": "La fonte verifica in modo indipendente la condizione di controllo.",
    "thisNativeEvidenceSourceIsNotSupported": "Questa fonte di prova nativa non è supportata.",
    "thatSourceCapabilityIsNotAvailable": "Quella capacità sorgente non è disponibile.",
    "selectAValidActiveControl": "Selezionare un controllo attivo valido.",
    "theRequestedMappingOrControlIsNoLongerAvailable": "La mappatura richiesta o il controllo non è più disponibile.",
    "mappingsCanOnlyTargetActiveControls": "Le mappe possono essere indirizzate solo ai Controlli Attivi.",
    "selectAValidEvidenceRelationship": "Selezionare un rapporto di prova valido.",
    "recordsConsideredPerSyncMustBeAWholeNumberFrom1To250": "I record considerati per sincronizzazione devono essere un numero intero da 1 a 250.",
    "theSourceConfigurationIsTooLarge": "La configurazione sorgente è troppo grande.",
    "thisSourceIsAlreadyMappedToThatControl": "Questa fonte è già mappata a quel Controllo.",
    "providerSourceCapabilityAndControlCannotBeChanged": "Provider, capacità di sorgente e controllo non possono essere modificati.",
    "youDoNotHavePermissionToChangeIntegrations": "Non hai il permesso di cambiare Integrazioni.",
    "theIntegrationsOperationCouldNotBeCompleted": "L'operazione Integrazioni non poteva essere completata.",
    "never": "Mai",
    "editMapping": "Modifica mappatura",
    "addMapping": "Aggiungi mappatura",
    "sourceCapability": "Capacità di sorgente",
    "activeControl": "Controllo attivo",
    "searchKeyOrTitle": "Chiave di ricerca o titolo...",
    "selectAnActiveControl": "Selezionare un controllo attivo",
    "relationship": "Relazioni",
    "recordsConsideredPerSync": "Registrazioni considerate per sincronizzazione",
    "limitsHowManyRecentSourceRecordsPrivanaReviewsDuringEachSync": "Limita quante fonti recenti registra Privana recensioni durante ogni sincronizzazione.",
    "enabled": "Abilitato",
    "saveMapping": "Salva la mappatura",
    "mappings": "mappature",
    "mapNativeSourceCapabilitiesToActiveControlsDisablingAMappingOnlyAffectsFutureSyncsHistoricalEvidenceRemainsUnchanged": "Mappa le capacità di origine native di Active Controls. La disattivazione di una mappatura influisce solo sulle sincronizzazioni future; la prova storica rimane invariata.",
    "noSupportedSourceCapabilitiesAreCurrentlyAvailableForThisClub": "Attualmente non sono disponibili funzionalità di sorgente supportate per questo club.",
    "addMapping2": "Aggiungi mappatura",
    "noMappingsConfigured": "Nessuna mappatura configurata.",
    "configuration": "Configurazione",
    "disabled": "Disabilitato",
    "latest": "Più recenti",
    "disable": "Disabilita",
    "enable": "Abilita",
    "syncCouldNotBeCompletedPleaseTryAgain": "Sync non potrebbe essere completato.",
    "loadingNativeIntegrations": "Caricamento delle integrazioni native...",
    "nativeEvidenceIntegrations": "Integrazioni di prove native",
    "configureAndOperateTrustedPrivanaSourcesThatProduceComplianceEvidence": "Configurare e utilizzare fonti attendibili Privana che producono prove di conformità.",
    "addIntegration": "Aggiungere l'integrazione",
    "addAnIntegration": "Aggiungi un'integrazione",
    "discoverTrustedEvidenceSourcesForYourAssuranceProgramme": "Scopri le fonti di prova attendibili per il tuo programma di assicurazione.",
    "useCompletedSafetyChecksAndRiskAssessmentsAsTrustedComplianceEvidence": "Utilizzare i controlli di sicurezza completati e le valutazioni dei rischi come prova di conformità affidabile.",
    "native": "Nativo",
    "comingSoon": "Arrivo presto",
    "bringIdentityMFAPrivilegedAccessAndSecurityAssuranceSignalsIntoPrivanaCompliance": "Portare i segnali di identità, MFA , accesso privilegiato e sicurezza in conformità Privana.",
    "moreComingSoon": "Presto arriveranno altri!",
    "privanaIsContinuallyExpandingTheSystemsThatCanContributeTrustedComplianceEvidence": "Privana sta espandendo continuamente i sistemi che possono contribuire ad una prova di conformità affidabile.",
    "nATIVE": "NATIVO",
    "configured": "Configurato",
    "readyToConfigure": "Pronti a configurare",
    "available2": "Disponibile",
    "unavailable": "Non disponibile",
    "enabledMappings": "Abilitato mappature",
    "evidenceProduced": "Prove prodotte",
    "lastOutcome": "Ultimo risultato",
    "completedWithErrors": "Completo di errori",
    "successful": "Successo",
    "notSynced": "Non sincronizzato",
    "sourceCapabilities": "Capacità di sorgente",
    "lastSync": "Ultimo messaggio",
    "viewEvidence": "Visualizzare le prove",
    "syncing": "Sincronizzazione...",
    "syncNow": "Sincronizzare ora",
    "syncComplete": "Sincronizzazione completa",
    "integrationUnavailable": "Integrazione non disponibile",
    "thisProviderIsNotCurrentlyAvailableForYourClubRefreshThePageOrContactAnAdministrator": "Questo provider non è attualmente disponibile per il tuo club. Aggiorna la pagina o contatta un amministratore.",
    "search": "Cerca...",
    "remediationActions": "azioni di bonifica",
    "actionsTrackTheWorkRequiredToRemediateComplianceFindings": "Le azioni tracciano il lavoro necessario per correggere i risultati di conformità.",
    "findingsTrackComplianceGapsIdentifiedThroughAssessmentsAndAssuranceReviews": "I risultati tracciano le lacune di conformità identificate attraverso valutazioni e recensioni di garanzia.",
    "raiseFindingsFromEligibleAssessmentResults": "Aumentare i risultati dei risultati di valutazione idonei.",
    "completionSummary": "Riepilogo del completamento",
    "blockedReason": "Ragione bloccata",
    "cancellationRationale": "Cancellazione razionale",
    "action": "Azione",
    "due": "Dovuto",
    "overdue2": " · overdue",
    "start": "Inizio",
    "block": "Blocca",
    "complete2": "Completo",
    "resume": "Ripresa",
    "unableToLoadFindings": "Incapace di caricare i risultati.",
    "closureSummary": "Riepilogo della chiusura",
    "complianceFindings": "Rilevazioni di conformità",
    "formalDeficienciesAndExceptionsRaisedFromCanonicalAssessmentResults": "Deficienze formali e eccezioni sollevate dai risultati della valutazione canonica.",
    "openFindings2": "Risultati aperti",
    "readyForReview": "Pronto per la recensione",
    "overdueActions": "Azioni sovrapposte",
    "findingStatus": "Situazione di ricerca",
    "findingSeverity": "Trovare la gravità",
    "allSeverities": "Tutte le severità",
    "overdue3": "in ritardo",
    "assessmentResult": "Risultato della valutazione",
    "closed": "Chiuso",
    "remediationActions2": "Azioni di bonifica",
    "actionTitle": "Titolo dell'azione",
    "selectActionOwner": "Selezionare il proprietario dell'azione",
    "addAction": "Aggiungi azione",
    "noRemediationActionsYet": "Ancora nessuna azione di bonifica.",
    "theDailyWorkQueueForResolvingComplianceFindings": "La coda di lavoro quotidiana per risolvere i risultati della conformità.",
    "actionStatus": "Stato d'azione",
    "allPriorities": "Tutte le priorità",
    "dueState": "Due stati",
    "allDueDates": "Tutte le date",
    "dueSoon": "Condividi su Twitter",
    "noDueDate": "Nessuna scadenza",
    "unknownFailure": "L'operazione di conformità non poteva essere completata.",
    "noControls": "Nessun controllo ancora",
    "noFrameworks": "Nessun quadro ancora",
    "noActions": "Nessuna azione di bonifica ancora",
    "noFindings": "Nessun risultato ancora",
    "evaluatedCount": "{evaluated} / {total} valutati",
    "completionPercent": "{percent} completo",
    "assessmentIncomplete": "Questa valutazione non può essere ancora completata. {count} controlli rimangono non valutati {references} .",
    "allStatus": "Tutti gli stati",
    "allFrameworks": "Tutti i quadri",
    "allAssessmentTypes": "Tutti i tipi di valutazione",
    "allResults": "Tutti i risultati",
    "stepNumber": "Fase {step}",
    "assessedScope": "{assessed} di {total} versioni quadro attuali valutate · {controls} controlli applicabili",
    "findingSeverityCounts": "{critical} critico · {high} alto",
    "dueCounts": "Due in 30 giorni · {overdue} in ritardo",
    "timesIn": "Tempi mostrati in {timezone}",
    "selectDate": "Seleziona {date}",
    "ownerName": "Proprietario: {owner}",
    "priorityLevel": "{priority} priorità",
    "moreCount": "+ {count} più",
    "openTarget": "Aperto {target}",
    "dateTime": "Data e ora",
    "orderNumber": "Ordine {order}",
    "referenceFor": "Riferimento quadro per {control}",
    "reorderControl": "Riordinare o rimuovere {control}",
    "previewName": "Anteprima · {name}",
    "versionSuccess": "Versione {status} con successo.",
    "versionNumber": "Versione {version}",
    "suggestedReviewCounts": "{total} suggerito Controlli · {approved} approvato · {awaiting} in attesa di revisione",
    "readyActiveCounts": "{active} / {total} Attivo · Pronta per attivare la versione",
    "reviewedControls": "{reviewed} di {total} Controlli esaminati",
    "selectControl": "Seleziona {control}",
    "activatedControls": "{count} controlli attivati.",
    "evidenceTransition": "Perche' questa prova e' {status}?",
    "analysingPolicy": "Analizzare {title} · {percent}",
    "documentsCountOne": "{count} documento",
    "documentsCountOther": "{count} documenti",
    "reviewCount": "Per vedere {count}",
    "completedCount": "Completato {count}",
    "addToFrameworkName": "Aggiungi a {name}",
    "importanceLevel": "{importance} importanza",
    "providerUnavailable": "La capacità di {provider} non è disponibile per questo club.",
    "providerMappings": "{provider} mappature",
    "elementDescription": "Utilizzare gli eventi di avviso monitorati e le eccezioni del mondo fisico come prova di conformità affidabile.",
    "mappingView": "Visualizza mappature",
    "mappingManage": "Gestione delle mappe",
    "configure": "Configurazione",
    "syncNeedsMapping": "Aggiungi almeno una mappatura abilitata prima della sincronizzazione.",
    "syncNeedsAvailable": "Abilitare una mappatura per una capacità di sorgente disponibile prima di sincronizzare.",
    "overdueCount": "{count} in ritardo",
    "insuranceQueued": "In coda",
    "insurancePreparingdocuments": "Preparazione dei documenti",
    "insuranceReadingpolicy": "Politica di lettura",
    "insuranceIdentifyingrequirements": "Requisiti di identificazione",
    "insuranceCheckingyourCompliancecontrols": "Controllare i controlli di conformità",
    "insurancePreparingrecommendations": "Preparare le raccomandazioni",
    "insuranceFinalisinganalysis": "Analisi finale",
    "insuranceAnalysisfailed": "Analisi fallita",
    "insuranceExclusions": "Conclusioni",
    "insuranceConditionsofcover": "Condizioni di copertura",
    "insuranceRecommendations": "Raccomandazione",
    "insuranceDefinitionspolicyinformation": "Definizioni e informazioni politiche",
    "insuranceClaimsnotification": "Reclami e notifica",
    "insuranceDataprotectionprivacy": "Protezione dei dati e privacy",
    "insuranceIncidentresponse": "Risposta incisiva",
    "insuranceOperationalresilience": "resilienza operativa",
    "insuranceSecurityrequirements": "Requisiti di sicurezza",
    "insuranceGovernancepeople": "Governance e persone",
    "insuranceOtherpolicywording": "Altre parole politiche",
    "evidenceMethodSummary": " · Prove: {method}",
    "diagnostic": "{message} (Codice: {code}; Richiesta: {request} )",
    "nativeChecklist": "Elenco di controllo di sicurezza: {title}",
    "nativeRisk": "Valutazione del rischio: {title}",
    "nativeElement": "Allerta degli elementi: {title}",
    "nativeResult": "Completato con il risultato {result} .",
    "nativeRiskDescription": "Punteggio di rischio {score}; stato {status} .",
    "controlCount": "{count} Controlli",
    "continue": "Continua",
    "messageControls": "{value1} ({value2} ) · {value3} · {value4} controlli",
    "messageCompleted2": "{value1} · {value2} · Completato {value3}",
    "messageCreated": "Creato {value1}",
    "messageEvaluated": "{value1} / {value2} valutati",
    "messageControlVersion": "{value1} · {value2} · Versione di controllo {value3}",
    "messageFinding": "Trovare {value1} · {value2}",
    "messageTimesShownIn": "Tempi mostrati in {value1}",
    "messageManifestV": "Manifesto v {value1} · SHA-256 {value2}",
    "messageTimesShownIn2": "Tempi mostrati in {value1}",
    "messageMore": "+ {value1} più",
    "messageAvailable": "{value1} disponibili",
    "messageVersion2": "{value1} · {value2} · Versione {value3}",
    "messageAssigned": "{value1} assegnati",
    "messageVersion22": "{value1} · {value2} · Versione {value3}",
    "messageFrameworkReferenceFor": "Riferimento quadro per {value1}",
    "messageControlsAssigned": "{value1} Controlli assegnati",
    "messageSuggestedEvidence": "{value1} · Prove consigliate: {value2}",
    "messagePrivanaTemplate": "Privana modello · {value1} Controlli",
    "messageSelected": "{value1} selezionato",
    "messageVersion": "Versione {value1}",
    "messageControls2": "{value1} Controlli",
    "messageReviewed": "{value1} / {value2} recensito",
    "messageVersion23": "{value1} · {value2} · Versione {value3}",
    "messageSelected2": "{value1} selezionato",
    "messageEvidence2": "{value1} · {value2} · Prove: {value3}",
    "messageSelected3": "{value1} selezionato",
    "messageVersion3": "Versione {value1}",
    "messagePage": "Pagina {value1} · {value2} record",
    "messageInsuranceIntelligence3": "Intelligenza assicurativa · {value1}",
    "messageAnalysing": "Analizzare {value1}",
    "messageOf": "{value1} · {value2} di {value3} pagine trattate",
    "messagePage2": "{value1} · pagina {value2} · Visualizza sorgente",
    "messageOf2": "{value1} di {value2} esaminati · {value3} rimanenti",
    "messageExistingMatches": "{value1} partite esistenti · {value2} suggerito Controlli · {value3} date · {value4} esigenze recensione",
    "messageReview": "Recensione {value1} →",
    "messageStatus2": "Stato: {value1}",
    "messageFrameworks2": "Quadri: {value1}",
    "messageLatestAssessment": "Valutazione più recente: {value1}",
    "messageEvidence3": "Prove: {value1}",
    "messageLibraryProvenance": "Provenza della biblioteca: {value1} · versione {value2} · {value3}",
    "messageTarget": "Obiettivo: {value1} · Versione {value2}",
    "messagePage3": "Pagina {value1} · Visualizza fonte",
    "messageAll": "Tutte le {value1} clausole estratte rimangono disponibili, raggruppate per una revisione più semplice.",
    "messageConfidencePage": "{value1} % di fiducia · pagina {value2}",
    "messagePage22": "{value1} · pagina {value2} · Visualizza sorgente",
    "messagePages": "{value1} · {value2} · {value3} pagine · {value4}",
    "messageVersion24": "{value1} · Versione {value2} · {value3} · {value4} Controlli",
    "messageEvaluation2": "Valutazione: {value1} · Prove: {value2}",
    "messagePrivanaLibrary": "Privana Biblioteca · {value1} · Versione {value2} · {value3}",
    "messagePage23": "{value1} · pagina {value2} · Visualizza sorgente",
    "messagePages2": "{value1} pagine",
    "messageMappings": "{value1} mappature",
    "messageLatest": "Ultimi {value1}",
    "messageOverdue3": "{value1} in ritardo",
    "criticalHigh": "Critico / alto",
    "frameworkControl": "Quadro / Controllo",
    "outlookRenewal": "Preparare {title} Rinnovo",
    "outlookPolicy": "Politica: {title}",
    "outlookInsurer": "Assicuratore: {name}",
    "outlookNumber": "Numero di politica: {number}",
    "outlookExpiry": "Scadenza: {date}",
    "futureRelease": "Questo spazio di lavoro è pronto per un futuro rilascio di conformità."
  },
  "enums": {
    "low": "Basso",
    "medium": "Medio",
    "high": "Alto",
    "critical": "Critico",
    "open": "Apri",
    "active": "Attivo",
    "draft": "Bozza",
    "retired": "Ritiro",
    "superseded": "Superato",
    "withdrawn": "Ritiro",
    "applicable": "Applicabile",
    "not_applicable": "Non applicabile",
    "under_review": "Rassegna",
    "in_progress": "In corso",
    "completed": "Completato",
    "cancelled": "Annullato",
    "accepted": "Accettato",
    "remediation_in_progress": "Rimediazione in progresso",
    "ready_for_review": "Pronti per la recensione",
    "closed": "Chiuso",
    "void": "Annullato",
    "blocked": "Bloccato",
    "compliant": "Conforme",
    "partially_compliant": "Parzialmente compatibile",
    "non_compliant": "Non conforme",
    "not_evaluated": "Non valutato",
    "initial": "Iniziativa",
    "periodic": "Periodico",
    "reassessment": "Rivalutazione",
    "manual": "Manuale",
    "automated": "Automatizzato",
    "integrated": "Integrazione",
    "hybrid": "Ibrido",
    "manual_attestation": "Attestazione manuale",
    "document": "Documento",
    "system_evidence": "Prove di sistema",
    "integrated_evidence": "Prove integrate",
    "sensor_telemetry": "Telemetria del sensore",
    "uploaded_document": "Documento scaricato",
    "privana_safety": "Privana Sicurezza",
    "privana_element": "Privana Elemento",
    "completed_checklist": "Elenco di controllo completo",
    "risk_assessment": "Valutazione del rischio",
    "alert_event": "Evento di avviso",
    "supports": "Supporti",
    "contradicts": "Contraddice",
    "remediates": "Remediati",
    "verifies": "Verifica",
    "control": "Controllo",
    "assessment": "Valutazione",
    "finding": "Trovare",
    "action": "Azione",
    "framework": "Quadro",
    "framework_version": "Versione Quadro",
    "evidence": "Prove",
    "evidence_link": "Link delle prove",
    "audit_pack": "Pacchetto Audit",
    "generating": "Generazione",
    "generated": "Generazione",
    "queued": "In coda",
    "processing": "Elaborazione",
    "failed": "Non riuscito",
    "error": "Errore",
    "uploaded": "Caricato",
    "uploading": "Caricamento",
    "policy_wording": "Criteri di Wording",
    "policy_schedule": "Programma delle politiche",
    "endorsement": "Esecuzione",
    "renewal_terms": "Termini di rinnovo",
    "supporting_document": "Documento di supporto",
    "other": "Altro",
    "to_review": "A proposito di",
    "reviewed": "Recensione",
    "adopted": "Adozione da parte del Parlamento europeo",
    "dismissed": "Annullamento della decisione n.",
    "exclusion": "Esclusione",
    "condition": "Condizione",
    "recommendation": "Raccomandazione",
    "definition": "Definizione",
    "informational": "Informativo",
    "coverage": "Copertura",
    "notification_obligation": "Obbligo di notifica",
    "warranty": "Garanzia",
    "obligation": "Obbligo",
    "assessmentCoverage": "Valutazione della valutazione",
    "findingResolution": "Trovare la risoluzione",
    "actionTimeliness": "Tempi di azione",
    "evidenceCoverage": "EvidenzeCoverage",
    "scanned": "Scansione",
    "created": "Creato",
    "unchanged": "Scambio",
    "linked": "Collegamento",
    "skipped": "Ignorato",
    "sourceErrors": "Errori origine",
    "linkErrors": "LinkErrore",
    "current": "Attuale",
    "historical": "Storia",
    "pass": "Passaggio",
    "fail": "Fail.",
    "review_due": "Recensione Due",
    "privana_object_storage": "Privana Archiviazione oggetti",
    "actions": "Azioni",
    "frameworks": "Quadri",
    "assessments": "Valutazione",
    "control_created": "Comando Creato",
    "control_updated": "Aggiornamento del controllo",
    "control_status_changed": "Stato di controllo Cambiato",
    "control_version_created": "Versione di controllo Creato",
    "framework_created": "Struttura creata",
    "framework_version_created": "Versione Quadro Creato",
    "framework_control_linked": "Controllo quadro Linked",
    "framework_control_unlinked": "Controllo quadro non collegato",
    "framework_controls_reconciled": "Controllo quadro riconciliato",
    "framework_control_copied": "Controllo quadro Copied",
    "framework_created_from_library": "Quadro Creato dalla Biblioteca",
    "control_created_from_library": "Controllo Creato dalla Biblioteca",
    "framework_status_changed": "Stato quadro Cambiato",
    "framework_version_status_changed": "Stato di versione quadro cambiato",
    "framework_applicability_changed": "Applicabilità quadro Cambiato",
    "assessment_created": "Valutazione Creata",
    "assessment_status_changed": "Stato di valutazione Cambiato",
    "assessment_results_initialized": "Risultati di valutazione",
    "assessment_result_recorded": "Risultato di valutazione Registrato",
    "finding_created": "Trovare Creato",
    "finding_metadata_changed": "Trovare i Metadati Cambiati",
    "finding_status_changed": "Trovare Stato Cambiato",
    "action_created": "Azione creata",
    "action_metadata_changed": "Metadati dell’azione modificati",
    "action_status_changed": "Stato d'azione modificato",
    "evidence_created": "Prove create",
    "evidence_document_uploaded": "Documento di prova Caricato",
    "evidence_metadata_changed": "Evidence Metadati Cambiati",
    "evidence_status_changed": "Stato delle prove Cambiato",
    "evidence_linked": "Prove collegate",
    "evidence_unlinked": "Prove non collegate",
    "evidence_source_mapping_created": "Evidence Source Mapping Creato",
    "evidence_source_mapping_changed": "Evidence Source Mapping Cambiato",
    "evidence_source_mapping_disabled": "Evidence Source Mapping Disabili",
    "trusted_evidence_created": "Prove affidabili Creato",
    "integrated_evidence_superseded": "Prove integrate Superata",
    "audit_pack_created": "Pacchetto Audit Creato",
    "audit_pack_generated": "Pacchetto Audit Generato",
    "audit_pack_voided": "Pacchetto Audit vuoto",
    "controls": "Controlli",
    "findings": "Risultati",
    "evidence_records": "Record di prove",
    "current_evidence": "Prove attuali",
    "current_documents_included": "Documenti attuali inclusi",
    "suggested": "Suggerito",
    "confirmed": "Confermato",
    "insurance": "Assicurazione",
    "insurance_policy": "Politica di assicurazione",
    "insurance_document": "Documento di assicurazione",
    "insurance_date": "Data dell'assicurazione",
    "insurance_analysis": "Analisi delle assicurazioni",
    "insurance_document_uploaded": "Documento di Assicurazione Caricato",
    "insurance_analysis_started": "Analisi delle assicurazioni Iniziato",
    "insurance_calendar_event_added": "Calendario delle assicurazioni Aggiunto",
    "preparing": "Preparazione",
    "validating": "Convalida",
    "evidence_source_mapping": "Mappatura delle fonti di prova",
    "verified": "Verificato",
    "partial": "Parziale",
    "not_started": "Non iniziato"
  },
  "controlValues": {
    "importance": {
      "low": "Basso",
      "medium": "Medio",
      "high": "Alto",
      "critical": "Critico"
    },
    "evaluationMethod": {
      "manual": "Analisi manuale",
      "automated": "Recensione automatizzata",
      "integrated": "Revisione integrata",
      "hybrid": "Recensione ibrida"
    },
    "evidenceMethod": {
      "manual_attestation": "Attestazione manuale",
      "document": "Recensione del documento",
      "system_evidence": "Prove di sistema",
      "integrated_evidence": "Prove integrate",
      "sensor_telemetry": "Telemetria del sensore",
      "hybrid": "Prove ibride"
    }
  },
  "assurance": {
    "Not Assessed": "Non Valutata",
    "At Risk": "A Risk",
    "Attention Needed": "Attenzione necessaria",
    "Strong": "Forte"
  },
  "report": {
    "title": "Pacchetto Audit",
    "brand": "CONCORRENZA PRIVANA",
    "generated": "Generazione {date}\nTimezone del club: {timezone}\nIntegrità SHA-256: {hash}",
    "executive": "Sommario esecutivo",
    "summary": "{assessment} contro {framework} {version} . Controlli: {controls} ; risultati: {findings} ; azioni: {actions} ; registri delle prove: {evidence} .",
    "frameworkAssessment": "Quadro e valutazione",
    "scope": "Quadro: {key} — {framework}\nVersione: {version} ({status})\nDate effettive: da {from} a {to}\nValutazione: {assessment} ({type} )\nIniziato: {started}\nCompletato: {completed}",
    "openEnded": "open end",
    "controlResults": "Risultati di controllo",
    "noNarrative": "Nessuna narrazione",
    "evaluated": " · Valutata {date}",
    "findings": "Risultati",
    "closed": " · Chiuso {date}",
    "noFindings": "Nessun risultato registrato.",
    "actions": "Azioni di bonifica",
    "due": "A causa di {date}",
    "completed": " · Completato {date}",
    "noActions": "Nessuna azione di bonifica registrata.",
    "evidence": "Registro delle prove",
    "noEvidence": "Nessuna prova registrata.",
    "audit": "Registro di audit",
    "integrity": "Generazione / Informazioni sull'integrità",
    "integrityText": "Formato del manifesto: {version}\nConvegno Hash: SHA-256 del carico canonico JSON escluso il socio dell'integrità.\nManifest hash: {hash}\nQuesta è una istantanea storica immutabile, non una certificazione di regolamentazione.",
    "page": "Privana · {key} · Pagina {page} di {total}"
  },
  "warnings": {
    "non_compliant": "La valutazione ha risultati non conformi",
    "open_findings": "I risultati aperti rimangono",
    "findings_review": "I risultati sono pronti per la recensione",
    "withdrawn_evidence": "Prove di prelievo sono collegate al campo di applicazione",
    "missing_evidence": "Controlli rilevanti non hanno prove positive attive"
  }
};
